import { compareHelpers } from '@approvalmax/utils';
import { backend } from 'modules/data';
import { GetBeneficiarySchema } from 'shared/data/webApp/v1';

import { messages } from './AddBeneficiaryPopupContent.messages';

/**
 * Perform data customization due to the specifics of the response of Airwallex
 * @param data
 */
export const tuneAirwallexFieldsAnswer = (
    data: backend.AirwallexBeneficiarySchemaAnswer
): backend.AirwallexBenefeciarySchemaField[] => {
    const isAUBpay =
        data.schema.condition.bank_country_code === 'AU' &&
        data.schema.condition.payment_method === 'LOCAL' &&
        data.schema.condition.local_clearing_system === 'BPAY';

    return data.schema.fields.map((item) => {
        let label = item.field.label;
        let description = item.field.description;
        let enabled = item.enabled;
        let fieldDefault = item.field.default;
        let path = item.path;
        let required = item.required;
        let options: typeof item.field.options | undefined = undefined;

        if (item.path === 'beneficiary.bank_details.local_clearing_system') {
            label = messages.localClearingSystem;
        }

        if (item.path === 'beneficiary.bank_details.account_routing_value2' && isAUBpay) {
            label = messages.customerReferenceNumber;
            description = '';
        }

        if (item.path === 'beneficiary.bank_details.account_routing_type2' && isAUBpay) {
            enabled = false;
            fieldDefault = 'bpay_customer_reference';
        }

        if (item.path === 'payment_method') {
            path = 'payment_methods';
        }

        if (item.path === 'beneficiary.bank_details.local_clearing_system') {
            required = true;
        }

        if (item.field.options) {
            options = item.field.options.sort((optionA, optionB) =>
                compareHelpers.stringComparator2Asc(optionA.label, optionB.label)
            );
        }

        return {
            ...item,
            enabled,
            path,
            required,
            field: {
                ...item.field,
                description,
                label,
                default: fieldDefault,
                options,
            },
        };
    });
};

export const getFieldByPath = (path: string, fieldsSchema?: GetBeneficiarySchema['response']['schema']['fields']) => {
    return fieldsSchema?.find((field) => field.path === path);
};
